<template>
	<div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" :id="id">
		<div class="p-4 b-b _600 nav-title">Viewer Controls</div>
		<div class="row m-0">
			<form role="form" class="p-4 col-sm-4">
				<p>Scoring Options</p>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.zoom_enabled" type="checkbox" />
						<i class="dark-white"></i> Zoom</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.angle_enabled" type="checkbox" />
						<i class="dark-white"></i> Angle Tool</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.rotate_enabled" type="checkbox" />
						<i class="dark-white"></i> Rotate</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.invert_enabled" type="checkbox" />
						<i class="dark-white"></i> Invert Colors</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.notes_enabled" type="checkbox" />
						<i class="dark-white"></i> Personal Notes</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.fit_to_content" type="checkbox" />
						<i class="dark-white"></i> Fit Page To Content</label
					>
				</div>
				<hr class="mb-4" />
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.show_timeout_timer" type="checkbox" />
						<i class="dark-white"></i> Show Timeout Timer</label
					>
				</div>
				<div class="checkbox">
					<label class="ui-check">
						<input v-model="item.hide_response_id" type="checkbox" />
						<i class="dark-white"></i> Hide Response ID</label
					>
				</div>
				<div class="checkbox">
					<label
						class="ui-check"
						v-tippy="{ theme: 'popover', placement: 'right-start' }"
						title="Greatly reduces the loading time of large media files, such as PDFs, but increases the amount of locked responses"
					>
						<input v-model="item.prefetch_media" type="checkbox" />
						<i class="dark-white"></i> Prefetch Media</label
					>
				</div>
			</form>
			<form role="form" class="p-4 col-sm-3">
				<div class="form-group">
					<label>Clip %</label>
					<percent-input v-model="item.clip_percent" />
				</div>
			</form>
		</div>
	</div>
</template>

<style>
</style>

<script>
import PercentInput from "@/components/PercentInput";

export default {
	name: "ItemEditViewer",

	props: ["id", "item", "defaultTab"],

	components: {
		"percent-input": PercentInput
	},

	data() {
		return {};
	},

	created() {},

	methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/item/ItemEditViewer.vue